module.exports = __webpack_public_path__ + "img/mobile/Background-freespins/fsbackground-portrait-wide@2x.jpg?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Background-freespins/fsbackground-portrait-wide@2x.jpg
// module id = 176
// module chunks = 0